<template>
<div class="chapter">
<div class="inner_page">
<h1 title="Epigraph"></h1>
<blockquote>
<p class="sectiontop">“Getting out of Dallas was the easy part.”</p>
<p style="text-align: right;">President John Kennedy to his brother Attorney General Robert Kennedy,<br/>
    March 21, 1966</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraph.vue?3ef8d2ae